export default "__VITE_ASSET__lfTXw$I9__"